import { Box, TextField } from '@mui/material';
import TrackerFilterPopoverGrid from './TrackerFilterPopoverGrid';

interface TrackerFilterTextFieldProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
}

export default function TrackerFilterTextField(props: TrackerFilterTextFieldProps) {
  const { label, value, onChange } = props;

  return (
    <TrackerFilterPopoverGrid>
      {label}
      <Box sx={{ display: 'flex', alignItems: 'center', width: '100%', height: '32px' }}>
        <TextField
          fullWidth
          size="smallCustom"
          variant="outlined"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          data-cy={`tracker-filter-text-field-${label}`}
        />
      </Box>
    </TrackerFilterPopoverGrid>
  );
}
